module.exports = __webpack_public_path__ + "img/text-align-right-01.6296c3c1.svg";